
export interface ReportGridHeader {
    displayText: string;
    key: string;
    primaryField?: string;
    sort?: string | null;
    isLink?: boolean;
    isDate?: boolean;
    isDateTime?: boolean;
    isTime?: boolean;
    enableFilter?: boolean;
    enableSearch?: boolean;
    uniqueItems?: any[];
    filteredUniqueItems?: { isChecked: boolean, label: string, id: number }[];
    selectedFilterCount?: string;
    headerSearchText?: string;
    actions?: IAction[];
    displayCustomData?: boolean;
    ngClass?: ICustomNgClass[];
    superScriptField?: string;
    superScriptData?: string;
    formatData?: boolean;
    defaultValue?: string;
    defaultDateFormat?: string;
    defaultTimeFormat?: string;
    selectRow?: boolean;
    selectId?: string;
    disableSelect?: string;
    allRowSelected?: boolean;
}

export interface ICustomNgClass {
    key: string;
    class: string;
}

export interface IAction {
    actionName?: string;
    description?: string;
    actionType: ActionType;
    actionHoverText?: string;
}

export enum ActionType {
    edit = 1,
    enable = 2,
    notify = 3,
    run = 4,
    delete = 5,
    exportExcel = 6,
    exportCsv = 7
}